import { returnStatuses } from '@reveni-io/reveni-ui'

import { getCustomDomain } from '../helpers/customDomain/customDomain'
import { navigateTo } from '../helpers/location/location'

export const shouldRenderCheckoutUrlButton = orderInfo => {
  return (
    orderInfo?.exchanged_for_order?.checkout_url !== null &&
    orderInfo?.exchanged_for_order?.checkout_url !== undefined &&
    orderInfo?.status !== returnStatuses.onHold
  )
}

export const redirect = ({ url, slug, orderStatus, identifier, orderNumber }) => {
  const customDomain = getCustomDomain()

  if (orderStatus === returnStatuses.cancelled) {
    if (customDomain) {
      navigateTo(`/?orderNumber=${orderNumber}&identifier=${identifier}`)
    } else {
      navigateTo(`/${slug}/?orderNumber=${orderNumber}&identifier=${identifier}`)
    }
  } else {
    if (customDomain) {
      navigateTo(url || '/')
    } else {
      navigateTo(url || `/${slug}`)
    }
  }
}

export const getCustomerEmail = orderInfo => {
  return orderInfo?.gift_recipient?.email || orderInfo?.customer_profile?.email?.email
}
